// extracted by mini-css-extract-plugin
module.exports = {"noCards":"_1lJ8ZPA_","emptyCard":"_1PG3-M0Z","noCardsTitle":"_1fxjvgvV"};